import { defineMessages } from "react-intl";
const messages = defineMessages({
    dashboardDevEnvironment: {
        id: "app.dashboard.dev.text",
        defaultMessage: "You're on Dev Environment!",
    },
});
export default messages;
